// site-search.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SiteSearchService {

  private shortCodeSubject = new BehaviorSubject<string | null>(null);
  private tableReadySubject = new BehaviorSubject<boolean>(false);

  /** Raw streams */
  shortCode$ = this.shortCodeSubject.asObservable();
  tableReady$ = this.tableReadySubject.asObservable();

  /** Emits shortcode ONLY when table is ready */
  shortCodeWhenTableReady$ = combineLatest([
    this.shortCode$,
    this.tableReady$
  ]).pipe(
    filter(([code, ready]) => !!code && ready),
    map(([code]) => code!)
  );

  setShortCode(code: string) {
    this.shortCodeSubject.next(code);
  }

  clearShortCode() {
    this.shortCodeSubject.next(null);
  }

  setTableReady(ready: boolean) {
    this.tableReadySubject.next(ready);
  }
}
